import _ from 'lodash'
import is from 'is_js'

export default {
	name : 'file-field',
	props : ['data'],
	data () {
		return {
			fileReady : this.data.fileReady,
      fileName  : this.data.fileReady ?  '... ' + this.data.value.data.name.substring(this.data.value.data.name.length - 20, this.data.value.data.name.length) : ''
		}
	},
	methods : {
		selectFile () {

			let vm = this

			vm.$refs.fileInput.click()

		},
		changeData (event) {

			let vm = this


			let files = event.target.files || event.dataTransfer.files

			if( files[0] ){

				vm.fileName = files[0].name

				let fileReader = new FileReader()

				if( vm.data.readAsDataURL ){

					fileReader.readAsDataURL(files[0])

				}else if( vm.data.readAsText ){

					fileReader.readAsText(files[0])

				}

				fileReader.onloadend = function(fileReaderEvent){

					let data = {
						data   : fileReaderEvent.target.result,
						format : files[0].type.substring( files[0].type.indexOf('/') + 1 ),
						size   : files[0].size / 1000000
					}

					if( vm.data.filters.formatsAllowed && !is.inArray( data.format, vm.data.filters.formatsAllowed ) ){

						let message = {
							message : [vm.$t('data_validator.file.format').replace( '%formats%', vm.data.filters.formatsAllowed.join(', ') )],
							type    : 'error'
						}

						vm.$root.$emit('showMessage', message)

						return

					}


					if( vm.data.filters.maxSize && data.size > vm.data.filters.maxSize ){

						let message = {
							message : [vm.$t('data_validator.file.size').replace( '%size%', vm.data.filters.maxSize )],
							type    : 'error'
						}

						vm.$root.$emit('showMessage', message)

						return

					}

					vm.fileReady = true

					if( vm.data.image ){

						var image = new Image()

						image.src = fileReaderEvent.target.result

						image.onload = function(){

							data.height = this.height
							data.width = this.width

							vm.sendData(data)

						}

					}else{

						vm.sendData(data)

					}

				}

			}

		},
		removeFile () {

			let vm = this

			vm.sendData({})

			setTimeout(() => {

				vm.fileReady = false

			}, 100)

		},
		sendData (data) {

			this.$emit('changeData', data)

		}
	}
}



// WEBPACK FOOTER //
// ./src/components/general/fields/file/script.js